export default [
  {
    title: 'مدیریت سفارش ها',
    icon: 'bx bx-store',
    children: [
      {
        title: 'سفارش ها',
        route: { name: 'order' },
        resource: 'OrderManager',
        action: 'show',
      },
      {
        title: 'دسته بندی ها',
        route: { name: 'ordercategory' },
        resource: 'OrderCategoryManager',
        action: 'show',
      },
      {
        title: 'فرآیندها',
        route: { name: 'ordercategoryprocess' },
        resource: 'OrderCategoryProcessManager',
        action: 'show',
      },
      {
        title: 'رنگ ها',
        route: { name: 'color' },
        resource: 'ColorManager',
        action: 'show',
      },
    ],
  },
  {
    title: 'مدیریت درمانگاه ها',
    icon: 'bx bx-store',
    children: [
      {
        title: 'درمانگاه ها',
        route: { name: 'clinic' },
        resource: 'ClinicManager',
        action: 'show',
      },
      {
        title: 'صورتحساب ها',
        route: { name: 'invoice' },
        resource: 'InvoiceManager',
        action: 'show',
      },
      {
        title: 'پرداخت ها',
        route: { name: 'payment' },
        resource: 'PaymentManager',
        action: 'show',
      },
      {
        title: 'تعرفه ها',
        route: { name: 'clinictariff' },
        resource: 'ClinicTariffManager',
        action: 'show',
      },
    ],
  },
]
